import { render } from "./TechShareView.vue?vue&type=template&id=c904f786&scoped=true"
import script from "./TechShareView.vue?vue&type=script&lang=js"
export * from "./TechShareView.vue?vue&type=script&lang=js"

import "./TechShareView.vue?vue&type=style&index=0&id=c904f786&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c904f786"]])

export default __exports__